import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";


import {
  postLogin

} from "../../../helpers/backend_helper";



function* loginUser({ payload: { user, history } }) {
  try {
      console.log("user saga", user);
      const response = yield call(postLogin, {
          userName:  user.userName,
          password: user.password
      });
       const data = JSON.stringify(response)
      localStorage.setItem("authUser", data);
      yield put(loginSuccess(response));
      history('/dashboard');
  } catch (error) {
   
     if(!error.response.result){
    yield put(apiError('Invalid User'))
  }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess(response));

    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);

  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
